module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel06_1280_1280_th-13a5448f9949443c6c521d3efebccb68.jpg";